import React from 'react';
import {Box, Tooltip} from "@chakra-ui/react";
import {LiaSlidersHSolid} from "react-icons/lia";
import {getLanguageDefaultConfig} from "../utils/utils.ts";
import _ from "lodash";
import {ILanguageConfiguration} from "../models/interfaces/languageConfiguration.interface.ts";
import useUserStore from "../store/useUserStore.ts";

interface LanguageDefaultConfigurationIconProps {
  lang: string;
  currentConfig: Partial<ILanguageConfiguration>;
  updateConfig: (config: Partial<ILanguageConfiguration>) => void;
}

const LanguageDefaultConfiguration: React.FC<LanguageDefaultConfigurationIconProps> = (
  {
    lang,
    currentConfig,
    updateConfig

  }) => {
  const {languageConfig} = useUserStore();

  const setDefaultConfig = () => {
    updateConfig(getLanguageDefaultConfig(languageConfig, lang))
  }

  const isDefaultConfig: boolean = _.isEqual(
    getLanguageDefaultConfig(languageConfig, lang),
    currentConfig
  );

  return (
    <Box
      className={`relative cursor-pointer ${isDefaultConfig ? 'opacity-40 pointer-events-none' : ''}`}
      onClick={() => !isDefaultConfig && setDefaultConfig()}
    >
      <Tooltip label="Use default configuration" hasArrow>
        <LiaSlidersHSolid size={"25px"} color={"white"} className="absolute right-0 top-2"/>
      </Tooltip>
    </Box>
  )
}

export default LanguageDefaultConfiguration;